import { Box, Typography } from "@mui/material";

const EmptyField = () => {
	return (
		<Box display="flex" justifyContent="center" alignItems="center">
			<Typography> - </Typography>
		</Box>
	);
};

export default EmptyField;
